import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Card } from '../_model/card';

const pathApi = 'Card';

@Injectable({
    providedIn: 'root',
})
export class CardService {

    constructor(private http: HttpClient) { }

    get(codigoSecao: string): Observable<Card[]> {
        return this.http.get<Card[]>(`${environment.URL_API}/${pathApi}/${codigoSecao}`);
    }
}